import axios from 'settings/axios'
import { apiEndpoints } from 'settings/_apiSettings'

interface Response {
  data: {
    persons: unknown[]
    pagination: unknown
  }
}

interface Error {
  response: {
    status: number
  }
}

interface ListProfessionalsHomeData {
  professionals: unknown[]
  pagination: unknown
}

interface Question {
  title: string
  answer: string
  info: string
}

interface MatchingProfessionalProps {
  planGroupName: string
  questions: Question[]
}

export const matchingProfessional = ({
  planGroupName,
  questions,
}: MatchingProfessionalProps): Promise<ListProfessionalsHomeData> => {

  const endpoint = apiEndpoints.PROFESSIONAL_HOME_MATCHING

  const payload = {
    plan_group_name: planGroupName,
    questions,
  }
  
  return new Promise<ListProfessionalsHomeData> ((resolve, reject) => {
    axios.post(endpoint, payload)
      .then((response: Response) => {
        const professionals = response.data.persons.map(person => person)
        const pagination = response.data.pagination

        resolve({ professionals, pagination })
      })
      .catch((error: Error) => {
        reject(error.response.status)
      })
  })
}